import { createAction } from 'redux-actions';

const prefix = 'LOADING';
export const ActionConstants = {
  ADD_ACTIONS: `${prefix}/ADD_ACTIONS`,
  REMOVE_ACTIONS: `${prefix}/REMOVE_ACTIONS`,
  CLEAR_ACTIONS: `${prefix}/CLEAR_ACTIONS`,
};

const add = createAction(ActionConstants.ADD_ACTIONS);
const remove = createAction(ActionConstants.REMOVE_ACTIONS);
const clear = createAction(ActionConstants.CLEAR_ACTIONS);

export default {
  add,
  remove,
  clear,
};



// WEBPACK FOOTER //
// ./src/redux-modules/loading-overlay/actions/index.js